import servicesIcon from '../../assets/Services.png';
import servicesIcon2 from '../../assets/Services-2.png';
import servicesIcon3 from '../../assets/Services-3.png';
import { useLanguage } from '../../context/LanguageContext';

const SERVICES = [
  {
    id: 'delivery',
    titleKey: 'services.delivery.title',
    descriptionKey: 'services.delivery.description',
    icon: servicesIcon,
  },
  {
    id: 'support',
    titleKey: 'services.support.title',
    descriptionKey: 'services.support.description',
    icon: servicesIcon2,
  },
  {
    id: 'guarantee',
    titleKey: 'services.guarantee.title',
    descriptionKey: 'services.guarantee.description',
    icon: servicesIcon3,
  },
];

const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section className="services" aria-label={t('services.aria_label')}>
      <div className="services__container">
        {SERVICES.map((service) => (
          <article key={service.id} className="services__card">
            <div className="services__icon">
              <img src={service.icon} alt={t(service.titleKey)} />
            </div>
            <div className="services__text">
              <h3>{t(service.titleKey)}</h3>
              <p>{t(service.descriptionKey)}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
